import React, { Component } from 'react';
import logo from '../assets/logo.svg';
import antd from '../assets/antd.svg';
import 'antd/dist/antd.css';
import '../styles/App.css';
import { Row, Col } from 'antd';

import {Switch, Route} from 'react-router-dom';
import QueueAnim from 'rc-queue-anim';


import {Post} from "./Post"
import {PostList} from "./PostList"

class App extends Component {
  render() {
    return (
      <div className="App">

        <header className="App-header">
          <a href={"https://reactjs.org"}>
            <img src={logo} className="App-logo App-logo-spin" alt="logo" />
          </a>

          <h1 className="App-title">Shaofan Lai's Blog (React reader)<sup>Beta</sup></h1>

          <a href="https://ant.design/">
            <img src={antd} className="App-logo" alt="antd" />
          </a>
        </header>

        <main>
          <Row type="flex" justify="center">
            <Col span={20} className={"main-container"}>

              <Switch>
                <Route exact path={"/"} render={()=><PostList/>}/>
                <Route path={"/post/:id"} render={({match})=><Post id={match.params.id}/>}/>
              </Switch>

              {/*<PostList/>*/}
              {/*<Post/>*/}

            </Col>
          </Row>
        </main>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js